import { IError } from 'types/graphqlTypes'
import { useCoverShipmentMutation } from '../graphql/CoverShipmentMutation'
import { useOfferShipmentMutation } from '../graphql/OfferShipmentMutation'
import { TCoverModalSchema } from '../schema/CoverModalSchema'
import { prepareCoverInput, prepareOfferInput } from '../utils'

export interface ICoverageMutationResult {
  shipmentId: string | undefined
  errors: IError[] | undefined
}

export interface IUseCoverageMutationsProps {
  shipmentId: string
}

const useCoverageMutations = ({ shipmentId }: IUseCoverageMutationsProps) => {
  const [coverLoad] = useCoverShipmentMutation()
  const [offerLoad] = useOfferShipmentMutation()

  const coverShipment = async (
    formData: TCoverModalSchema,
    shipmentTimezone: string
  ): Promise<ICoverageMutationResult> => {
    const { data } = await coverLoad({
      variables: {
        input: prepareCoverInput(shipmentId, formData, shipmentTimezone),
      },
    })

    const { coverShipment } = data || {}
    const { errors, shipment } = coverShipment || {}
    const { id: sId } = shipment || {}
    return { shipmentId: sId, errors }
  }

  const offerShipment = async (formData: TCoverModalSchema): Promise<ICoverageMutationResult> => {
    const { data } = await offerLoad({
      variables: {
        input: prepareOfferInput(shipmentId, formData),
      },
    })

    const { offerShipment } = data || {}
    const { errors, shipment } = offerShipment || {}
    const { id: sId } = shipment || {}
    return { shipmentId: sId, errors }
  }

  return {
    coverShipment,
    offerShipment,
  }
}

export default useCoverageMutations
